module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/115-hungary-2c92748f8ae92389c8b9aaf9c0da1ca9.svg";